import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { colors } from "../../theme/colors";

export const UserManagementPageStyled = styled(Box)(({ theme }) => ({
  ".page-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },

  ".content-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "24px",
  },

  ".filters-container": {
    display: "flex",
    alignItems: "flex-end",
    gap: "16px",
  },

  ".specialty-text": {
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text?.primary || colors.text.primary,
  },

  ".no-specialty-text": {
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.text?.secondary || colors.text.secondary,
  },

  ".actions-cell": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
  },

  ".action-button": {
    minWidth: "auto",
    padding: "4px 8px",
    fontSize: "13px",
    textTransform: "none",
  },
}));
